import { g as d } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as m } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconObject",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, u = ["aria-label", "data-qa", "aria-hidden"], f = ["clip-path"], p = ["id"];
function h(e, t, r, _, Z, i) {
  return n(), o("svg", {
    "aria-label": r.ariaLabel,
    class: s([i.iconSizeClass, "d-icon d-icon--object"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Object",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...t[0] || (t[0] = [
      a("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "m1.54 5.404.788-.578-.306-.93a4.47 4.47 0 0 0-.483 1.508Zm1.205-2.51.566 1.718.696.218L5.5 3.746v-.733L4.038 1.95a4.513 4.513 0 0 0-1.292.944Zm2.47-1.325.785.57.786-.57a4.528 4.528 0 0 0-1.572 0Zm2.748.38L6.501 3.013v.734L7.99 4.828l.707-.23.55-1.714a4.513 4.513 0 0 0-1.284-.934Zm2.171.424a5.5 5.5 0 0 0-8.848 6.462.5.5 0 0 0 .078.126 5.5 5.5 0 0 0 10.11-2.425.5.5 0 0 0 .02-.265 5.478 5.478 0 0 0-1.253-3.774.5.5 0 0 0-.107-.124Zm-.16 1.515-.292.913.773.556a4.468 4.468 0 0 0-.48-1.47Zm.487 2.706L9.008 5.548l-.709.23-.57 1.753.427.59 1.815-.002a4.47 4.47 0 0 0 .49-1.525ZM9.244 9.12h-.978l-.302.93c.48-.233.913-.55 1.28-.93Zm-2.455 1.31.559-1.721-.428-.592H5.08l-.43.595.567 1.72a4.53 4.53 0 0 0 1.572-.002Zm-2.75-.38-.304-.922-.965.004c.364.376.793.688 1.269.919Zm-2-1.915 1.8-.007.432-.597-.568-1.75-.692-.216L1.545 6.64c.076.535.247 1.04.493 1.496Zm2.647-2.563.502 1.545h1.625l.502-1.545L6 4.618l-1.314.955Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])], 8, f),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, u);
}
const I = /* @__PURE__ */ m(c, [["render", h]]);
export {
  I as default
};
//# sourceMappingURL=object.js.map
